export type FormAddressType = {
  street: string;
  unit: string;
  city: string;
  state: string;
  country: string;
  zip: string;
  latitude: string;
  longitude: string;
};

export type AddresFormPlaceholders = {
  street?: string;
  unit?: string;
  city?: string;
  state?: string;
  country?: string;
  zip?: string;
};

export const defaultAddress = {
  street: '',
  unit: '',
  city: '',
  state: '',
  country: 'US',
  zip: '',
  latitude: '',
  longitude: '',
};
